export default __webpack_public_path__ + "static/whatsgoingon-1920x630-0c07d6ab36bd24dae4288f308639f1bd.jpg";